import { PulseEnvironment } from '@pulse/browser-shared';
import { BuiltinEvents, PulseEvent, PulseMessagePriority } from '@pulse/common';
import { TabOpenerDetector } from './tabs';

export class NavigationEventService {
    constructor(
        private tabOpenerDetector: TabOpenerDetector,
        private env: PulseEnvironment,
    ) {}

    send(initial: boolean, source?: 'session_reset' | 'consent_change') {
        const opener = this.tabOpenerDetector.getOpener(true);

        const event: PulseEvent = {
            event_type: BuiltinEvents.NAVIGATION,
            pulse: 'event',
            data: {
                initial,
                source,
                click_source: {},
            },
            event_priority: PulseMessagePriority.High,
        };

        if (opener?.element && this.tabOpenerDetector.isFirstNavigation() && initial) {
            event.data['click_source'] = {
                section: opener?.name,
                group: opener?.group,
                popup_component: opener?.popupComponent,
                popup_component_type: opener?.popupComponentType,
                tab_id: opener?.id,
                url: opener?.url,
                type: opener?.type,
                element: {
                    id: opener?.element?.id,
                    name: opener?.element?.name,
                    type: opener?.element?.nodeName,
                    class_list: opener?.element?.classList,
                    value: opener?.element?.text,
                },
                additional_properties: opener?.additionalProperties,
            };
        }
        const triggerEvent = this.tabOpenerDetector.getTriggerEvent(initial);

        if (!this.tabOpenerDetector.isFirstNavigation() && triggerEvent?.element) {
            event.data['click_source'] = {
                section: triggerEvent?.name,
                group: triggerEvent?.group,
                popup_component: triggerEvent?.popupComponent,
                popup_component_type: triggerEvent?.popupComponentType,
                tab_id: triggerEvent?.id,
                url: triggerEvent?.url,
                element: {
                    id: triggerEvent?.element?.id,
                    name: triggerEvent?.element?.name,
                    type: triggerEvent?.element?.nodeName,
                    class_list: triggerEvent?.element?.classList,
                    value: triggerEvent?.element?.text,
                },
                additional_properties: triggerEvent?.additionalProperties,
            };
        }
        this.env.win.dataLayer?.push(event as unknown as Record<string, unknown>);
    }
}
